if (!customElements.get('dpc-cuban-gallery')) {
  customElements.define('dpc-cuban-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-gallery-config]').textContent);
      this.image = this.querySelector('.dpc-cuban-image');
      this.stage = this.querySelector('.dpc-cuban-stage');
      this.thumbnails = this.querySelector('.dpc-cuban-thumbnails');
      this.videoStage = this.querySelector('.dpc-cuban-video-stage');
      this.videoTemplate = this.querySelector('[data-gallery-video-template]');
      const videoConfig = this.querySelector('[data-gallery-video]');
      this.videoConfig = videoConfig ? JSON.parse(videoConfig.textContent) : null;
      if (this.videoTemplate) this.videoStage.append(this.videoTemplate.content.cloneNode(true));
      this.dialog = this.querySelector('dialog');
      this.zoomImage = this.dialog.querySelector('img');
      this.stage.addEventListener('click', () => {
        if (this.swiped) { this.swiped = false; return; }
        this.zoomImage.src = this.current.url;
        this.zoomImage.alt = this.current.alt;
        this.dialog.showModal();
      });
      this.stage.addEventListener('pointerdown', event => { this.startX = event.clientX; });
      this.stage.addEventListener('pointerup', event => {
        if (this.startX == null) return;
        const delta = event.clientX - this.startX;
        this.startX = null;
        if (Math.abs(delta) > 50) {
          this.swiped = true;
          this.show((this.index + (delta < 0 ? 1 : this.photos.length - 1)) % this.photos.length);
        }
      });
      this.stage.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show((this.index + (event.key === 'ArrowRight' ? 1 : this.photos.length - 1)) % this.photos.length);
      });
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.setGauge(this.dataset.gauge, true);
    }

    setVariant(variant, resetPhoto = false) {
      const title = variant.options?.[0] || variant.title || '';
      const gauge = String(title).match(/(\d+)\s*mm/i)?.[1];
      if (gauge) this.setGauge(gauge, resetPhoto);
    }

    setGauge(gauge, force = false) {
      if (!force && gauge === this.gauge) return;
      if (!this.config?.[gauge]?.length) return;
      this.gauge = gauge;
      this.dataset.gauge = gauge;
      this.photos = [...this.config[gauge], ...(this.config.shared || []), ...(this.videoConfig ? [this.videoConfig] : [])];
      this.thumbnails.replaceChildren();
      this.photos.forEach((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', this.dataset.viewLabel + ' ' + (index + 1) + ': ' + photo.alt);
        const img = document.createElement('img');
        img.srcset = [90, 180, 270].map(width => `${this.sizedUrl(photo.url, width)} ${width}w`).join(', ');
        img.sizes = '90px';
        img.src = this.sizedUrl(photo.url, 180);
        img.alt = photo.alt;
        img.width = 90;
        img.height = 90;
        img.loading = 'lazy';
        img.decoding = 'async';
        button.append(img);
        if (photo.type === 'video') {
          const play = document.createElement('span');
          play.className = 'dpc-cuban-video-badge';
          play.textContent = '▶';
          play.setAttribute('aria-hidden', 'true');
          button.append(play);
        }
        button.addEventListener('click', () => this.show(index));
        this.thumbnails.append(button);
      });
      if (this.dialog.open) this.dialog.close();
      this.show(0);
    }

    sizedUrl(url, width) {
      const sized = new URL(url, window.location.origin);
      sized.searchParams.set('width', width);
      return sized.href;
    }

    show(index) {
      this.index = index;
      this.current = this.photos[index];
      const isVideo = this.current.type === 'video';
      this.stage.hidden = isVideo;
      this.videoStage.hidden = !isVideo;
      if (!isVideo) {
        this.videoStage.querySelector('video')?.pause();
        const renderedFile = new URL(this.image.src, window.location.origin).pathname.split('/').pop();
        const selectedFile = new URL(this.current.url, window.location.origin).pathname.split('/').pop();
        const keepInitialSource = !this.hasShown && this.image.srcset && renderedFile === selectedFile;
        if (!keepInitialSource) {
          this.image.srcset = [360, 540, 750, 1000, 1200, 1600].map(width => `${this.sizedUrl(this.current.url, width)} ${width}w`).join(', ');
          this.image.sizes = this.image.sizes || '(min-width: 1440px) 750px, (min-width: 990px) calc((100vw - 13rem) * .65), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
          this.image.src = this.sizedUrl(this.current.url, 1600);
        }
        this.hasShown = true;
        this.image.alt = this.current.alt;
      }
      this.stage.setAttribute('aria-label', this.dataset.viewLabel + ' ' + (index + 1) + ': ' + this.current.alt);
      [...this.thumbnails.children].forEach((button, i) => {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      const selected = this.thumbnails.children[index];
      if (selected) {
        const itemRect = selected.getBoundingClientRect();
        const rowRect = this.thumbnails.getBoundingClientRect();
        if (itemRect.left < rowRect.left) this.thumbnails.scrollLeft += itemRect.left - rowRect.left;
        else if (itemRect.right > rowRect.right) this.thumbnails.scrollLeft += itemRect.right - rowRect.right;
      }
    }
  });
}



